<template>
  <div class="thanksLetters">
    <div class="top_bar">
      <div class="t_inner">
        <h3>{{ $t("nav.references") }}</h3>
      </div>
    </div>
    <VueGallery :images="imageTarget" :index="index" @close="index = null"></VueGallery>
    <Carousel
      ref="ThanksCarousel"
      class="row as-thanks-carousel"
      :autoplay="false"
      :nav="false"
      :items="3"
      :dots="false"
      :loop="true"
      :responsiveClass="true"
      :responsive="{0:{items:1,nav:false},1000:{items:3,nav:false}}"
    >
      <template slot="prev">
        <span class="prev"></span>
      </template>
      <template slot="next">
        <span class="next"></span>
      </template>
      <div
        class="item"
        v-for="(item, itemIndex) in items"
        :key="itemIndex"
        @click="ChangeImage(itemIndex, item)"
      >
        <div class="img_holder">
          <img :src="require('../assets/images/thanksLetters/'+item.img)">
          <span>{{item.name}}</span>
        </div>
      </div>
    </Carousel>
  </div>
</template>

<script>
import Carousel from "vue-owl-carousel";
import VueGallery from "vue-gallery";
export default {
  data() {
    return {
      index: null,
      imageTarget: [],
      items: [
        {
          name: "BUNGE",
          img: "bunge.jpg",
        },
        {
          name: "DANIELI",
          img: "daniela.jpg",
        },
        {
          name: "ГУАЛАПАК УКРАИНА",
          img: "gyalapak.jpg",
        },
        {
          name: "МЕГАЛАЙН ТРЦ ЛАВИНА",
          img: "megaline.jpg",
        },
        {
          name: "АЛКОМ ОЛСИДЗ",
          img: "olsidz.jpg",
        },
        {
          name: "УКРБУД",
          img: "ukrbyd.jpg",
        },
        {
          name: "ОРЕКСИМ",
          img: "orexim.jpg",
        }
      ]
    };
  },
  methods: {
    ChangeImage: function(index) {
      this.index = index;
      for (var i = 0; i < this.items.length; i++) {
        this.imageTarget.push(
          require("../assets/images/thanksLetters/" + this.items[i].img)
        );
      }
    }
  },
  components: {
    Carousel,
    VueGallery
  }
};
</script>
